import FingerprintJS from "@fingerprintjs/fingerprintjs-pro";

type FingerprintPayload = {
  request_id: string;
  visitor_id: string;
};

const STORAGE_KEY = "Fingerprint";

let agentPromise: Promise<any> | null = null;

const getAgent = () => {
  if (!agentPromise) {
    agentPromise = FingerprintJS.load({
      apiKey: "xjY6J2diKiKBvhcfrh8Y",
      region: "eu",
    });
  }
  return agentPromise;
};

const withTimeout = async <T>(promise: Promise<T>, timeoutMs: number): Promise<T> => {
  let timeoutId: number | undefined = undefined;
  const timeoutPromise = new Promise<T>((_, reject) => {
    timeoutId = window.setTimeout(() => reject(new Error("timeout")), timeoutMs);
  });
  try {
    return await Promise.race([promise, timeoutPromise]);
  } finally {
    if (timeoutId !== undefined) {
      clearTimeout(timeoutId);
    }
  }
};

export const getFingerprintPayload = async (timeoutMs: number = 1500): Promise<FingerprintPayload | null> => {
  try {
    const agent = await withTimeout(getAgent(), timeoutMs);
    const result = await withTimeout(agent.get(), timeoutMs);
    const visitorId = result?.visitorId;
    const requestId = result?.requestId;
    if (visitorId && requestId) {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ visitorId, requestId })
      );
      return { visitor_id: String(visitorId), request_id: String(requestId) };
    }
  } catch {
  }
  return null;
};

export const getCachedVisitorId = (): string => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return "";
    const v = JSON.parse(raw)?.visitorId;
    return v ? String(v) : "";
  } catch {
    return "";
  }
};

export const warmupFingerprint = (): void => {
  const run = async () => {
    await getFingerprintPayload(3000);
  };
  if ("requestIdleCallback" in window) {
    (window as any).requestIdleCallback(() => {
      run();
    });
  } else {
    setTimeout(() => {
      run();
    }, 0);
  }
};
